var _excluded = ["desc", "focusable", "title", "iconName", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
var svg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.147 21.999h-1.315a2.16 2.16 0 01-2.228-1.526l-1.617-7.11a.494.494 0 00-.588-.379l-.01.003a.5.5 0 00-.376.598l1.618 7.114a3.138 3.138 0 003.201 2.3h1.316a.5.5 0 100-1zm13.464-9.013a.494.494 0 00-.595.364l-.003.012-1.617 7.107a2.161 2.161 0 01-2.229 1.53h-1.331a.5.5 0 000 1h1.331a3.14 3.14 0 003.203-2.304l1.617-7.11a.5.5 0 00-.375-.598zM22.214 8a1.786 1.786 0 11-1.785 1.786A1.786 1.786 0 0122.214 8zM10.541 21.003h3.907l.183-1.063a1.316 1.316 0 01.373-.724H10.54a.893.893 0 00.001 1.787zm9.727-.12c.044.015.085.035.131.045a1.742 1.742 0 002.091-1.303l1.26-5.43a1.742 1.742 0 10-3.393-.793l-.001.007-1.26 5.429a1.75 1.75 0 00-.043.369h-2.62a1 1 0 00-.99.855l-1.015 5.916a.893.893 0 001.767.26v-.002l.91-5.242 3.163-.001z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 2a14 14 0 1014 14A14 14 0 0016 2zm13 14a12.938 12.938 0 01-3.134 8.452L7.553 6.139A12.983 12.983 0 0129 16zM3 16a12.953 12.953 0 013.139-8.447l18.313 18.313A12.99 12.99 0 013 16z"
}));

var Icon = function Icon(_ref) {
  var desc = _ref.desc,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      title = _ref.title,
      iconName = _ref.iconName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: String(focusable),
    className: classNames('rds-svg--feet-on-seet-prohibited-icon', className)
  }, rest, svg.props), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), svg.props.children);
};

Icon.propTypes = {
  desc: string,
  focusable: bool,
  title: string,
  iconName: string,
  className: string
};
Icon.displayName = 'FeetOnSeetProhibitedIcon';
export default Icon;